export const AI_RESOURCE_LINK_CLASS_NAME = 'ai-resource-link'
